import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { NavigationService } from '@core/services';
import { regexes } from '@core/utils';

export const setPasswordCheckTokenGuard: CanActivateFn = (
  activatedRoute: ActivatedRouteSnapshot
) => {
  const navigationService = inject(NavigationService);
  //const activatedRoute = inject(ActivatedRoute);

  console.log('params: ', activatedRoute.params);
  if ('token' in activatedRoute.params) {
    const token = activatedRoute.params['token'];
    if (regexes.PASSWORDTOKEN.test(token)) {
      return true;
    }
  }
  navigationService.navigateToLogin();
  return false;
};
